import { HIDE_WARNING_DIALOG, SHOW_WARNING_DIALOG } from "../actions/warning";

const INITIAL_STATE = {
  open: false,
  message: "",
};

const warning = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_WARNING_DIALOG:
      return {
        open: true,
        message: action.payload.message,
      };
    case HIDE_WARNING_DIALOG:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};

export default warning;